/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocationCityIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-location-city"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.32 20.3L1.32 8.55Q1.32 7.42 2.09 6.66Q2.85 5.9 3.98 5.9L8.28 5.9L8.28 4.85Q8.28 4.33 8.49 3.84Q8.7 3.35 9.07 2.98L10.15 1.9Q10.93 1.13 12.01 1.13Q13.1 1.13 13.88 1.9L14.95 2.98Q15.32 3.35 15.53 3.84Q15.72 4.33 15.72 4.85L15.72 10.7L20.02 10.7Q21.15 10.7 21.91 11.46Q22.68 12.22 22.68 13.35L22.68 20.3Q22.68 21.43 21.91 22.19Q21.15 22.95 20.02 22.95L3.98 22.95Q2.85 22.95 2.09 22.19Q1.32 21.43 1.32 20.3ZM3.98 20.3L6.13 20.3L6.13 18.15L3.98 18.15ZM3.98 15.5L6.13 15.5L6.13 13.35L3.98 13.35ZM3.98 10.7L6.13 10.7L6.13 8.55L3.98 8.55ZM10.93 20.3L13.07 20.3L13.07 18.15L10.93 18.15ZM10.93 15.5L13.07 15.5L13.07 13.35L10.93 13.35ZM10.93 10.7L13.07 10.7L13.07 8.55L10.93 8.55ZM10.93 5.9L13.07 5.9L13.07 3.75L10.93 3.75ZM17.88 20.3L20.02 20.3L20.02 18.15L17.88 18.15ZM17.88 15.5L20.02 15.5L20.02 13.35L17.88 13.35Z" fill={color} />
    </svg>
  );
}
